class AccordionMenu {
  constructor() {
    this.initAccordions();
    this.setupEventListeners();
  }

  initAccordions() {
    // Initialize all accordion panels as closed
    document.querySelectorAll('.c-accordion__panel').forEach(panel => {
      panel.style.maxHeight = null;
    });
  }

  setupEventListeners() {
    // Handle header clicks (entire li element)
    document.querySelectorAll('.js-accordion-header[data-toggle="accordion"]').forEach(header => {
      header.addEventListener('click', (e) => {
        // Don't trigger if clicked directly on a link (allow normal navigation)
        if (e.target.closest('.js-accordion-link') && e.target === e.target.closest('.js-accordion-link')) {
          return;
        }
        this.toggleAccordion(header);
      });
    });

    // Handle arrow button clicks
    document.querySelectorAll('.dropdown-arrow').forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const header = e.target.closest('.js-accordion-header');
        if (header) {
          this.toggleAccordion(header);
        }
      });
    });
  }

  toggleAccordion(header) {
    const isExpanded = header.getAttribute('aria-expanded') === 'true';
    const panelId = header.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    const arrowIcon = header.querySelector('.inactive-arrow, .active-arrow');
    const parentId = header.closest('.c-accordion__panel')?.id;
    const level = header.getAttribute('data-level');

    // Toggle aria-expanded state
    header.setAttribute('aria-expanded', !isExpanded);

    // Toggle panel visibility with animation
    if (panel) {
      if (isExpanded) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        
        // Close other panels at the same level
        if (parentId) {
          const parentPanel = document.getElementById(parentId);
          parentPanel.querySelectorAll('.js-accordion-header').forEach(sibling => {
            if (sibling !== header && sibling.getAttribute('aria-expanded') === 'true') {
              this.toggleAccordion(sibling);
            }
          });
        }
      }
    }

    // Toggle arrow icon
    if (arrowIcon) {
      arrowIcon.classList.toggle('active-arrow');
      arrowIcon.classList.toggle('inactive-arrow');
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new AccordionMenu();
});